<template>
<div class="wrap">
  <div class="header-warp">
    <b-tabs class="tab_bar" v-model="tab" fill justified style="width: 100%">
      <b-tab :title="$t('site_report.site_report')" :active="!$store.getters.getUnregisteredSite" title-link-class="tab_text tab"></b-tab>
      <b-tab :title="$t('site_report.unregistered_site')"  title-link-class="tab_text tab"></b-tab>
      <b-tab :title="$t('site_report.report_result')" :active="$store.getters.getUnregisteredSite" title-link-class="tab_text tab"></b-tab>
    </b-tabs>
		<b-input-group class="mt-3" style="width: 480px; font-family: $korean_gd_14_r;">
		  <b-form-input v-model="search_name"
					 v-if="tab===TAB.REPORT"
					 style="height: 40px; font-size: 18px; font-family: KoreanGD14R;"
					 :placeholder='$t("site_report.search_site_name_placeholder")'
					 @keydown.enter="onSearch"
					 @click="onSearch">
		  </b-form-input>
		  <b-input-group-append>
				<b-button
				  v-if="tab===TAB.REPORT"
				  variant="white"
				  class="transparent"
				  style="height: 40px;border: 1px solid #ced4da;"
				  @click="onSearch"
				>
				  <b-icon icon="search" variant="primary"></b-icon>
				</b-button>
			  </b-input-group-append>
		</b-input-group>

    <p  class="contentLabel" style="margin-top: 10px;">{{u.format($t('site_report.report_award'),1000)}}</p>
    <p v-if="tab===TAB.UNREGISTER" class="contentLabel2" style="margin:5px 0 10px 0">{{$t('site_report.report_exception_unregister')}}</p>
    <p v-else class="contentLabel2" style="margin:5px 0 10px 0">{{$t('site_report.report_exception')}}</p>
  </div>
  <div class="content_wrap pb-2" v-if="showSale" ref="wrap" @scroll="onScroll" :style="{marginBottom:contentMargin}">
    <div class="container pt-2">
      <SiteItem
        v-for="(item , i) in saleList"
        :item="item"
        @remove="onRemove"
        :isReport="tab === TAB.REPORT"
        :isResult="tab === TAB.RESULT"
        :key="i"/>
      <div class="align-horizontal center mt-5" v-if="saleList.length === 0">
        <span v-if="tab === TAB.REPORT" class="no_result">
          {{search_name == '' ? $t('map.no_search_keyword') : $t('map.no_search_result')}}
        </span>
        <span v-else class="no_result">
          {{$t('site_report.no_report_result')}}
        </span>
      </div>
    </div>
  </div>
  <div class="content_wrap mt-2" style="margin-bottom: 0;" v-else>
    <UnregisteredSite :hide-nav-bar="true" @cancel="tab=TAB.RESULT"/>
  </div>
  <Navbar
   :bar-visible="showNavBar"
  />
</div>
</template>

<script>
import Navbar from '../../../controls/navbar'
import SiteItem from "../../../controls/SiteItem";
import Utils from "../../../../config/utils";
import InputSearch from "../admin/controls/input_search";
import {IS_UI_MODE} from "../../../../config/constant";
import RegNewOpenSite1 from "../more/RegGeneralOrNewOpenSite1";
import UnregisteredSite from "../more/UnregisteredSite";

const u = require('util');
const TAB= {
  REPORT: 0,
  UNREGISTER: 1,
  RESULT: 2,
}

export default {
  name: "SiteReport",
  components: {
    UnregisteredSite,
    RegNewOpenSite1,
    Navbar,
    SiteItem,
    InputSearch,
  },
  data: function() {
    return {
      TAB:TAB,
      u:u,
      tab: TAB.REPORT,
      showNavBar:true,
      showSale:true,
      contentMargin:'4.5em',
      search_name:'',

      saleList:[],
      pageNum:1,
      loadingEnd:false,

      // currentItem:null,
      // showSiteReportPopup:false,
    }
  },
  methods:{
    onScroll(){
      if (this.saleList.length === 0)
        return;
      else {
        let wrap = this.$refs.wrap;
        if(wrap.scrollHeight - Math.ceil(wrap.scrollTop) === wrap.clientHeight){ //end of scroll
          if (!this.loadingEnd){
            this.getList();
          }
        }
      }

    },

    initList() {
        this.pageNum = 1;
        this.loadingEnd = false;
        this.saleList =  [];
       this.getList();
    },

    onSearch(){
      this.initList();
    },

    onRemove(idx){
      this.saleList= this.saleList.filter(it => {
        return it.f_idx != idx;
      });
    },

    getList(isRefresh = false){
      if (isRefresh){
        this.pageNum = 1;
        this.loadingEnd = false;
        this.saleList = [];
      }

      if (this.loadingEnd) {
        return;
      }

      // if (this.tab == TAB.REPORT && !Utils.isEmpty(this.search_name)){
      if (this.tab == TAB.REPORT){
        if (!Utils.isEmpty(this.search_name.trim())) {
          Utils.requestGet(
            this.$c.API.Site.getSiteForReport,
            {
              site_name: this.search_name,
              page_num: this.pageNum,
            },
          ).then(result => {
            if (result.code == this.$c.API_RES_CODE.SUCCESS) {
              this.loadingEnd = result.data.count > result.data.list.length;
              // loadingEnd: true,
              this.pageNum = ++this.pageNum;
              this.saleList = this.saleList.concat(result.data.list);
            } else {
              Utils.toast(this, result.msg);
            }
          });
        } else {
          this.saleList = [];
        }
      } else if(this.tab == TAB.RESULT) {
        Utils.requestGet(
          this.$c.API.Site.getSiteForReportResult,
          {
            site_name: this.search_name,
            page_num: this.pageNum,
          },
        ).then(result => {
          if (result.code == this.$c.API_RES_CODE.SUCCESS) {
            this.loadingEnd = result.data.count > result.data.list.length;
            // loadingEnd: true,
            this.pageNum = ++this.pageNum;
            this.saleList = this.saleList.concat(result.data.list);
          } else {
            Utils.toast(this, result.msg);
          }
        });
      }

    },

  },
  computed:{

  },
  beforeRouteLeave(to, from, next) {
    if (this.$store.getters.getUnregisteredSite) {
      this.$store.commit('setUnregisteredSite', false);
    }
    next();
  },
  mounted() {
    this.$store.commit('setTabIndex', this.$c.MAIN_TAB.MORE);
    this.initList();
  },
  watch:{
    tab(){
      if (this.tab == TAB.UNREGISTER){
        this.showNavBar = false;
        this.contentMargin = '0';
        this.showSale = false;
      }
      else{
        this.initList();
        this.showNavBar = true;
        this.showSale = true;
        this.contentMargin = '4.5em';
      }
        // this.initList();
    }
  },
}
</script>

<style scoped lang="scss">
  @import '../../../../assets/css/main/interest/Interest.scss';
  .wrap{
    height: 100vh;
    display: flex;
    flex-direction: column;
    width: 480px;
    margin: auto;
  }
  .header-warp{
    background: white;
    width: 100%;
    z-index: 1;
    display: flex;
    flex-direction: column;
    justify-content:center;
    align-items: center;
  }
  .contentLabel{
    font-size: $fs_18;
    color: $c_457fff;
    text-align: center;
    font-family: $korean_gd_14_r;
    text-decoration: underline;
    line-height: 24px;
    margin-bottom: 0;
  };
  .contentLabel1{
    font-size: $fs_13;
    color: $c_457fff;
    text-align: center;
    font-family: $korean_gd_12_r;
    // line-height: 27;
  };
  .contentLabel2{
    font-size: $fs_16;
    color: #cf0000;
    text-align: center;
    font-family: $korean_gd_14_r;
    margin-bottom: 0;
  };

  .content_wrap{
    border-top: solid 0.5px #eae9e9;
    overflow: auto;
    height: 100%;
    margin-bottom: $main_tab_height;
    width: 480px;
    margin: auto;
  }

  .no_result{
    font-size: $fs_18;
    font-family: $korean_gd_13_r;
  }
 </style>



// WEBPACK FOOTER //
// src/components/contents/main/site_report/SiteReport.vue